import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../pages/Login.vue";
import deslogin from "../pages/deslogin.vue"
import Home from "../pages/Home.vue";

// 直播抽奖
import livelottery from "../pages/livelottery.vue";
// 活动抽奖
import eventlottery from "../pages/eventlottery.vue";

// 欢迎首页
import welcome from "../pages/system/welcome.vue";


/* ------------------- 店铺管理 ------------------ */
// 店铺信息
import brand from "../pages/storeManagement/brand.vue";
// 商品管理
import commoditymanagement from "../pages/storeManagement/commoditymanagement.vue";
// 设计师
import listdes from "../pages/storeManagement/listdes.vue";
// 装修案例
import decorationCases from "../pages/storeManagement/decorationCases.vue";
// 施工管理
import construction from "../pages/storeManagement/construction.vue";
// 企业信息
import enterpriseinfo from "../pages/storeManagement/enterpriseinfo.vue";

// 探店
import findshop from "../pages/storeManagement/findshop.vue"
// 品牌店铺详情
import seeFindshop from "../pages/storeManagement/seeFindshop.vue"


/* ------------------- 订单管理 ------------------ */
// 店铺订单
import storeOrder from "../pages/orderManagement/storeOrder.vue";
// 预约到店
import appointment from "../pages/orderManagement/appointment.vue";
// 预约设计
import DesCustomer from "../pages/orderManagement/desCustomer.vue";
// 询低价管理-new
import askForLowPrice from "../pages/orderManagement/askForLowPrice.vue";
// 询低价管理-old
import LowPriceManagement from "../pages/orderManagement/LowPriceManagement.vue";



/* ------------------- 运营管理 ------------------ */
// 店铺活动
import BusinessActivitiesList from "../pages/operationManagement/BusinessActivitiesList.vue";
// 幸运购活动
import shoppingActivities from "../pages/operationManagement/shoppingActivities.vue";
// 优惠券管理
import couponList from "../pages/operationManagement/couponList.vue";
// 创建优惠券
import couponAdd from "../pages/operationManagement/couponAdd.vue";
// 付费推广
import paidPromotion from "../pages/operationManagement/paidPromotion.vue";
// 直播管理
import livebroadcast from "../pages/operationManagement/livebroadcast.vue";
// 店铺数据
import storeData from "../pages/operationManagement/storeData.vue";
// 商家联盟
import merchantAlliance from "../pages/operationManagement/merchantAlliance.vue";
// 店铺渠道
import merchantChannel from "../pages/operationManagement/merchantChannel.vue";
// 分享审核
import shareReview from "../pages/operationManagement/shareReview.vue";
// 客源大厅
import resourceLibrary from "../pages/operationManagement/resourceLibrary.vue";
// 客源变现
import customersalerecord from "../pages/operationManagement/customersalerecord.vue";


/* ------------------- 交付管理 ------------------ */

// 交付宝
import deliveryTreasure from "../pages/PointsMall/deliveryTreasure.vue";
// 销售记录
import salesRecords from "../pages/PointsMall/salesRecords.vue";


/* ------------------- 平台管理 ------------------ */
// 入驻管理
import settledEnterprise from "../pages/platformManagement/settledEnterprise.vue";
// 分享申诉
import sharingAppeals from "../pages/platformManagement/sharingAppeals.vue";
// 联盟审核
import merchantAllianceAudit from "../pages/platformManagement/merchantAllianceAudit.vue";
// 代购管理
import CustomerPurchaseOrder from "../pages/platformManagement/CustomerPurchaseOrder.vue";
// 创客管理
import together from "../pages/platformManagement/together.vue";
// 城市合作
import cityPartner from "../pages/platformManagement/cityPartner.vue";
// 广告管理
import banner from "../pages/platformManagement/banner.vue";
// 退客审核
import cancelOrder from "../pages/platformManagement/cancelOrder.vue";
// 导入客户管理
import beginners from "../pages/platformManagement/beginners.vue";
// 客源审核
import customersourcereview from "../pages/platformManagement/customersourcereview.vue";
// 分佣管理
import commissionSharing from "../pages/platformManagement/commissionSharing.vue"
// 套餐包管理
import productpackage from "../pages/platformManagement/productpackage.vue"
// 精准客户审核
import PrecisionCustomerAudit from "../pages/platformManagement/PrecisionCustomerAudit.vue"



/* ------------------- 财务管理 ------------------ */
// 收款设置
import collectionSettings from "../pages/financialManagement/collectionSettings.vue";
// 微信账户
import wechataccount from "../pages/financialManagement/vxaccount.vue";
// 店铺钱包
import vmacount from "../pages/financialManagement/vmacount.vue";
// 收款管理
import collectionManagement from "../pages/financialManagement/collectionManagement.vue";
// 提现审核
import withdrawalOfBalance from "../pages/financialManagement/withdrawalOfBalance.vue";
// 交易数据
import transactionsPlatform from "../pages/financialManagement/transactionsPlatform.vue";
// 资金管理
import vmmanage from "../pages/financialManagement/vmmanage.vue";
// 渠道分佣
import channelsharing from "../pages/financialManagement/channelsharing.vue";



/* ------------------- 内容管理 ------------------ */
// 店铺评论
import storeReviews from "../pages/contentManagement/storeReviews.vue";
// 评价管理
import comments from "../pages/contentManagement/comments.vue";
// 文章管理
import articleReviewAndRelease from "../pages/contentManagement/articleReviewAndRelease.vue";
// 装修必看
import guessYouLikeIt from "../pages/contentManagement/guessYouLikeIt.vue";
// 装修日记
import decoration from "../pages/contentManagement/decoration.vue";
// 搜索推荐
import searchRecommendation from "../pages/contentManagement/searchRecommendation.vue";



/* ------------------- 用户管理 ------------------ */
// 用户中心
import user from "../pages/userManagement/user.vue";
// 邀请人变更
import inviterchange from "../pages/userManagement/inviterchange.vue";
// 会员记录
import analysis from "../pages/userManagement/analysis.vue";
// 会员管理
import MemberList from "../pages/userManagement/MemberList.vue";
// 会员卡管理详情
import MemberDetails from "../pages/userManagement/MemberDetails.vue";
// 会员推广
import MembershipCardPromotion from "../pages/userManagement/MembershipCardPromotion.vue";



/* ------------------- 积分商城 ------------------ */
// 积分规则
import IntegralRule from "../pages/PointsMall/IntegralRule.vue";
// 积分商城
import PointsMallList from "../pages/PointsMall/PointsMallList.vue";
// 兑换记录
import ExchangeRecords from "../pages/PointsMall/ExchangeRecords.vue";



/* ------------------- 系统管理 ------------------ */
// 账号管理
import staff from "../pages/system/staff.vue";
// 角色管理
import role from "../pages/system/role.vue";
// 品牌管理
import brandManagement from "../pages/system/brandManagement.vue";
// 品类管理
import categoryManagement from "../pages/system/categoryManagement.vue";
// 开放城市
import opencity from "../pages/system/opencity.vue";
// 客源定价
import customprice from "../pages/system/customprice.vue";
// 功能配置
import functionconfig from "../pages/system/functionconfig.vue";
// 精准客户配置
import PrecisionCustomerConfig from "../pages/system/PrecisionCustomer.vue";
// 录音识别配置
import ringcontentkeyword from "../pages/system/ringcontentkeyword.vue";

// 修改密码 & 修改手机
import modify from "../pages/system/modify.vue";


/* ------------------- 页面基本类似 ------------------ */
// 运营管理 - 店铺红包 
import shopRedPacketActivity from "../pages/operationManagement/shopRedPacketActivity.vue";
// 平台管理 - 店铺红包 
import areaRedpacketActivity from "../pages/platformManagement/areaRedpacketActivity.vue";

// 运营管理 - 精准客户 
import PrecisionCustomerList from "../pages/operationManagement/PrecisionCustomerList.vue";



// 字典管理
import dictionary from "../pages/system/dictionary.vue";

// 平台公告
import notice from "../pages/system/notice.vue";

// 数据
import activityDataList from "../pages/operationManagement/activityDataList.vue";
// 直播审核
import liveBroadcastOpeningAudit from "../pages/staging/liveBroadcastOpeningAudit.vue";

// 店铺提现审核
import storeCashWithdrawalAudit from "../pages/staging/storeCashWithdrawalAudit.vue";
// 提现打款管理
import withdrawalAndPaymentManagement from "../pages/staging/withdrawalAndPaymentManagement.vue";


// 平台活动
import ActivityManagementList from "../pages/staging/ActivityManagementList.vue";
// 审核商家活动
import AuditBusinessList from "../pages/staging/AuditBusinessList.vue";

// 配置优惠券
import Configuration from "../pages/staging/Configuration.vue";


// 品牌店铺 
import brandStore from "../pages/staging/brandStore.vue";


// 订单管理
import order from "../pages/staging/order.vue";
// 售后管理
import refund from "../pages/staging/refund.vue";
// 结算管理
import settle from "../pages/staging/settle.vue";
// 提现管理
import withdraw from "../pages/staging/withdraw.vue";


import goods from "../pages/staging/goods.vue";
// 评论管理
import comment from "../pages/staging/comment.vue";
// 商品数据分析
import goodsAnalysis from "../pages/staging/goodsAnalysis.vue";
// 平台管家管理
import butler from "../pages/staging/butler.vue";
//装修公司编辑页
import company from "../pages/staging/compant.vue"
// 商家审核
import examine from "../pages/staging/examine.vue"
// 公告
import noticeList from "../pages/staging/noticeList.vue";


//营销管理
import Markegoods from "../pages/staging/markegoods.vue"
//活动管理
import Activitycolumn from "../pages/staging/Activitycolumn.vue"

import ActivityManagement from "../pages/staging/ActivityManagement.vue"
import ActivityDetails from "../pages/staging/ActivityDetails.vue"
// 活动佣金配置
import ActivityCommission from "../pages/staging/ActivityCommission.vue"
// 售后管理 - 退款
import serviceRefund from "../pages/staging/serviceRefund.vue"
// 售后管理 - 换货
import serviceExchange from "../pages/staging/serviceExchange.vue"
// 售后管理 - 维修
import serviceRepair from "../pages/staging/serviceRepair.vue";



Vue.use(VueRouter);
const routes = [{
        path: "/",
        redirect: '/login',
        hidden: true
    },{
        path: "/login",
        component: Login,
        hidden: true //不显示在导航中
    },{
        path: "/deslogin",
        component: deslogin,
        hidden: true // 不显 
    },{
        path: "/livelottery",
        component: livelottery,
        hidden: true //不显示在导航中
    },{
        path: "/eventlottery",
        component: eventlottery,
        hidden: true //不显示在导航中
    },
    // 欢迎首页
    {
        path: "/",
        component: Home,
        name: "欢迎首页",
        children: [{
            path: "/welcome",
            component: welcome,
            meta: [{ name: "欢迎首页" }]
        }]
    },

    // 店铺管理
    {
        path: "/",
        component: Home,
        name: "店铺管理",
        children: [{
            path: "/brand",
            component: brand,
            meta: [{ name: '店铺管理'}, { name: "店铺信息" }]
        },{
            path: "/findshop",
            component: findshop,
            meta: [{ name: '店铺管理'}, { name: "店铺详情" }]
        },{
            path: "commoditymanagement",
            component: commoditymanagement,
            meta: [{ name: '店铺管理'}, { name: "商品管理" }]
        },{
            path: "listdes",
            component: listdes,
            meta: [{ name: '店铺管理'}, { name: "设计师" }]
        },{
            path: "decorationCases",
            component: decorationCases,
            meta: [{ name: '店铺管理'}, { name: "装修案例" }]
        },{
            path: "construction",
            component: construction,
            meta: [{ name: '店铺管理'}, { name: "施工管理" }]
        },{
            path: "enterpriseinfo",
            component: enterpriseinfo,
            meta: [{ name: '店铺管理'}, { name: "企业信息" }]
        },
        
        {
            path: "/goods",
            component: goods,
            meta: [{ name: '商家管理'}, { name: "商品管理" }]
        },{
            path: "/comment",
            component: comment,
            meta: [{ name: '商家管理'}, { name: "评论管理" }]
        },{
            path: "/goodsAnalysis",
            component: goodsAnalysis,
            meta: [{ name: '商家管理'}, { name: "商品数据分析" }]
        },{
            path: "/Activitycolumn",
            component: Activitycolumn,
            meta: [{ name: '商家管理'}, { name: "活动栏目" }]
        },{
            path: "brandStore",
            component: brandStore,
            meta: [{ name: '商家管理'}, { name: "品牌店铺" }]
        },{
            path: "/seeFindshop",
            component: seeFindshop,
            meta: [{ name: '商家管理'}, { name: "品牌店铺" }]
        },]
    },

    // 订单管理
    {
        path: "/",
        component: Home,
        name: "订单管理",
        children: [{
            path: '/storeOrder',
            component: storeOrder,
            meta: [{ name: '订单管理'}, { name: "店铺订单" }]
        },{
            path: "/appointment",
            component: appointment,
            meta: [{ name: '订单管理'}, { name: "预约到店" }]
        },{
            path: "/DesCustomer",
            component: DesCustomer,
            meta: [{ name: '订单管理'}, { name: "预约设计" }]
        },{
            path: "/LowPriceManagement",
            component: LowPriceManagement,
            meta: [{ name: '订单管理'}, { name: "询价管理old" }]
        },{
            path: "/askForLowPrice",
            component: askForLowPrice,
            meta: [{ name: '订单管理'}, { name: "询价管理" }]
        },
        
        {
            path: "/order",
            component: order,
            meta: [{ name: '订单管理'}, { name: "订单管理" }]
        },{
            path: "/refund",
            component: refund,
            meta: [{ name: '订单管理'}, { name: "售后管理" }]
        },{
            path: "/serviceRefund",
            component: serviceRefund,
            meta: [{ name: '订单管理'}, { name: "售后管理 / 退款详情" }]
        },{
            path: "/serviceExchange",
            component: serviceExchange,
            meta: [{ name: '订单管理'}, { name: "售后管理 / 换货详情" }]
        },{
            path: "/serviceRepair",
            component: serviceRepair,
            meta: [{ name: '订单管理'}, { name: "售后管理 / 维修详情" }]
        },{
            path: "/settle",
            component: settle,
            meta: [{ name: '订单管理'}, { name: "结算管理" }]
        },{
            path: "/withdraw",
            component: withdraw,
            meta: [{ name: '订单管理'}, { name: "提现审核" }]
        }]
    },

    // 运营管理
    {
        path: "/",
        component: Home,
        name: "运营管理",
        children: [{
            path: "/BusinessActivitiesList",
            component: BusinessActivitiesList,
            meta: [{ name: '运营管理'}, { name: "店铺活动" }]
        },{
            path: "/shoppingActivities",
            component: shoppingActivities,
            meta: [{ name: '运营管理'}, { name: "幸运购"}]
        },{
            path: "/couponList",
            name: "couponList",
            component: couponList,
            meta: [{ name: '运营管理'}, { name: "优惠券" }]
        },{
            path: "/couponAdd",
            component: couponAdd,
            meta: [{ name: '运营管理'}, { name: "创建优惠券" }]
        },{
            path: '/paidPromotion',
            component: paidPromotion,
            meta: [{ name: '运营管理'}, { name: "付费推广" }]
        },{
            path: "/livebroadcast",
            component: livebroadcast,
            meta: [{ name: '运营管理'}, { name: "直播管理"}]
        },{
            path: '/storeData',
            component: storeData,
            meta: [{ name: '运营管理'}, { name: "店铺数据" }]
        },{
            path: '/merchantAlliance',
            component: merchantAlliance,
            meta: [{ name: '运营管理'}, { name: "商家联盟" }]
        },{
            path: '/merchantChannel',
            component: merchantChannel,
            meta: [{ name: '运营管理'}, { name: "店铺渠道" }]
        },{
            path: "shareReview",
            component: shareReview,
            meta: [{ name: '运营管理'}, { name: "分享审核" }]
        },{
            path: "/resourceLibrary",
            component: resourceLibrary,
            meta: [{ name: '运营管理'}, { name: "客源大厅" }]
        },{
            path: "/customersalerecord",
            component: customersalerecord,
            meta: [{ name: '运营管理'}, { name: "客源变现" }]
        },{
            path: "/activityDataList",
            component: activityDataList,
            meta: [{ name: '运营管理'}, { name: "数据"}]
        },{
            path: "shopRedPacketActivity",
            component: shopRedPacketActivity,
            meta: [{ name: '运营管理'}, { name: "店铺红包" }]
        }, {
            path: "PrecisionCustomerList",
            component: PrecisionCustomerList,
            meta: [{ name: '运营管理' }, { name: "精准客户" }]
        },



        {
            path: "/ActivityCommission",
            component: ActivityCommission,
            meta: [{ name: '运营活动'}, { name: "活动佣金配置" }]
        },{
            path: "/ActivityManagementList",
            component: ActivityManagementList,
            meta: [{ name: '运营活动'}, { name: "平台活动" }]
        },{
            path: "/AuditBusinessList",
            component: AuditBusinessList,
            meta: [{ name: '运营活动'}, { name: "审核商家活动" }]
        },
        // {
        //     path: "/ActivityManagement",
        //     component: ActivityManagement,
        //     meta: [{ name: '促销管理'}, { name: "平台活动" }]
        // },
        {
            path: "/ActivityDetails",
            component: ActivityDetails,
            meta: [{ name: '促销管理'}, { name: "活动管理 / 活动详情" }]
        },{
            path: "/markegoods",
            component: Markegoods,
            meta: [{ name: '促销管理'}, { name: "砍价管理 / 商品管理" }]
        },{
            path: "/Configuration",
            component: Configuration,
            meta: [{ name: '促销管理'}, { name: "砍价管理 / 商品配置" }]
        }]
    },
    
    // 交付管理
    {
        path: "/",
        component: Home,
        name: "交付管理",
        children: [{
            path: "/deliveryTreasure",
            component: deliveryTreasure,
            meta: [{ name: '交付管理'}, { name: "交付宝" }]
        },{
            path: "/salesRecords",
            component: salesRecords,
            meta: [{ name: '交付管理'}, { name: "销售记录" }]
        },]
    },

    // 平台管理
    {
        path: "/",
        component: Home,
        name: "平台管理",
        children: [{
            path: "settledEnterprise",
            component: settledEnterprise,
            meta: [{ name: '平台管理'}, { name: "入驻管理" }]
        },{
            path: "sharingAppeals",
            component: sharingAppeals,
            meta: [{ name: '平台管理'}, { name: "分享申诉" }]
        },{
            path: '/merchantAllianceAudit',
            component: merchantAllianceAudit,
            meta: [{ name: '平台管理'}, { name: "联盟审核" }]
        },{
            path: "/CustomerPurchaseOrder",
            component: CustomerPurchaseOrder,
            meta: [{ name: '平台管理'}, { name: "代购管理" }]
        },{
            path: "/together",
            component: together,
            meta: [{ name: '平台管理'}, { name: "创客管理" }]
        },{
            path: "cityPartner",
            component: cityPartner,
            meta: [{ name: '平台管理'}, { name: "城市合作" }]
        },{
            path: "/banner",
            component: banner,
            meta: [{ name: '平台管理'}, { name: "广告管理" }]
        },{
            path: "/liveBroadcastOpeningAudit",
            component: liveBroadcastOpeningAudit,
            meta: [{ name: '平台管理'}, { name: "直播审核" }]
        },{
            path: "/cancelOrder",
            component: cancelOrder,
            meta: [{ name: '平台管理'}, { name: "退客审核" }]
        },{
            path: "/beginners",
            component: beginners,
            meta: [{ name: '平台管理'}, { name: "导入客户管理" }]
        },{
            path: "areaRedpacketActivity",
            component: areaRedpacketActivity,
            meta: [{ name: '平台管理'}, { name: "店铺红包" }]
        },{
            path: "/customersourcereview",
            component: customersourcereview,
            meta: [{ name: '平台管理'}, { name: "客源审核" }]
        },{
            path: "/commissionSharing",
            component: commissionSharing,
            meta: [{ name: '平台管理'}, { name: "分佣管理" }]
        },{
            path: "/productpackage",
            component: productpackage,
            meta: [{ name: '平台管理'}, { name: "套餐包管理" }]
        }, {
            path: "/PrecisionCustomerAudit",
            component: PrecisionCustomerAudit,
            meta: [{ name: '平台管理' }, { name: "精准客户审核" }]
        },]
    },
    
    // 财务管理
    {
        path: "/",
        component: Home,
        name: "财务管理",
        children: [{
            path: "collectionSettings",
            component: collectionSettings,
            meta: [{ name: '财务管理'}, { name: "收款设置" }]
        },{
            path: "/wechataccount",
            component: wechataccount,
            meta: [{ name: '财务管理'}, { name: "微信账户" }]
        },{
            path: "/vmacount",
            component: vmacount,
            meta: [{ name: '财务管理'}, { name: "店铺钱包" }]
        },{
            path: "collectionManagement",
            component: collectionManagement,
            meta: [{ name: '财务管理'}, { name: "收款管理" }]
        },{
            path: "/withdrawalOfBalance",
            component: withdrawalOfBalance,
            meta: [{ name: '财务管理'}, { name: "提现审核" }]
        },{
            path: "/transactionsPlatform",
            component: transactionsPlatform,
            meta: [{ name: '财务管理'}, { name: "交易数据" }]
        },{
            path: "/vmmanage",
            component: vmmanage,
            meta: [{ name: '财务管理'}, { name: "资金管理" }]
        },{
            path: "/channelsharing",
            component: channelsharing,
            meta: [{ name: '财务管理'}, { name: "渠道分佣" }]
        },


        {
            path: "/storeCashWithdrawalAudit",
            component: storeCashWithdrawalAudit,
            meta: [{ name: '财务管理'}, { name: "店铺提现审核" }]
        },{
            path: "/withdrawalAndPaymentManagement",
            component: withdrawalAndPaymentManagement,
            meta: [{ name: '财务管理'}, { name: "提现打款管理" }]
        }]
    },

    // 内容管理
    {
        path: "/",
        component: Home,
        name: "内容管理",
        children: [{
            path: "/storeReviews",
            component: storeReviews,
            meta: [{ name: '内容管理'}, { name: "店铺评价" }]
        },{
            path: "/comments",
            component: comments,
            meta: [{ name: '内容管理'}, { name: "评价管理" }]
        },{
            path: "/articleReviewAndRelease",
            component: articleReviewAndRelease,
            meta: [{ name: '内容管理'}, { name: "文章管理" }]
        },{
            path: "/guessYouLikeIt",
            component: guessYouLikeIt,
            meta: [{ name: '内容管理'}, { name: "装修必看" }]
        },{
            path: '/decoration',
            component: decoration,
            meta: [{ name: '内容管理'}, { name: "装修日记" }]
        },{
            path: "/searchRecommendation",
            component: searchRecommendation,
            meta: [{ name: '内容管理'}, { name: "搜索推荐" }]
        },]
    },

    // 用户管理
    {
        path: "/",
        component: Home,
        name: "用户管理",
        children: [{
            path: "/user",
            component: user,
            meta: [{ name: '用户管理'}, { name: "用户中心" }]
        },{
            path: "/inviterchange",
            component: inviterchange,
            meta: [{ name: '用户管理'}, { name: "邀请人变更" }]
        },{
            path: "/analysis",
            component: analysis,
            meta: [{ name: '用户管理'}, { name: "会员记录" }]
        },{
            path: "/MemberList",
            component: MemberList,
            meta: [{ name: '用户管理'}, { name: "会员管理" }]
        },{
            path: "/MemberDetails",
            component: MemberDetails,
            meta: [{ name: '会员卡管理'}, { name: "会员卡详情" }]
        },{
            path: "/MembershipCardPromotion",
            component: MembershipCardPromotion,
            meta: [{ name: '用户管理'}, { name: "会员推广" }]
        },


        {
            path: "/butler",
            component: butler,
            meta: [{ name: '用户管理'}, { name: "平台管家管理" }]
        },{
            path: "/examine",
            component: examine,
            meta: [{ name: '用户管理'}, { name: "商家资料申请" }]
        },{
            path: "company",
            component: company,
            meta: [{ name: '用户管理'}, { name: "装修公司详情" }]
        }]
    },

    // 积分商城
    {
        path: "/",
        component: Home,
        name: "积分商城",
        children: [{
            path: "/IntegralRule",
            component: IntegralRule,
            meta: [{ name: '积分商城' }, { name: "积分规则" }]
        }, {
            path: "/PointsMallList",
            component: PointsMallList,
            meta: [{ name: '积分商城'}, { name: "积分商城" }]
        }, {
            path: "/ExchangeRecords",
            component: ExchangeRecords,
            meta: [{ name: '积分商城'}, { name: "兑换记录" }]
        }]
    },

    // 系统管理
    {
        path: "/",
        component: Home,
        name: "系统管理",
        children: [{
            path: "/staff",
            component: staff,
            meta: [{ name: '系统管理'}, { name: "账号管理" }]
        },{
            path: "/role",
            component: role,
            meta: [{ name: '系统管理'}, { name: "角色管理" }]
        },{
            path: "/brandManagement",
            component: brandManagement,
            meta: [{ name: '系统管理'}, { name: "品牌管理" }]
        },{
            path: "/categoryManagement",
            component: categoryManagement,
            meta: [{ name: '系统管理'}, { name: "品类管理" }]
        },{
            path: "/opencity",
            component: opencity,
            meta: [{ name: '系统管理'}, { name: "开放城市" }]
        },{
            path: "/customprice",
            component: customprice,
            meta: [{ name: '系统管理'}, { name: "客源定价" }]
        },{
            path: "/dictionary",
            component: dictionary,
            meta: [{ name: '系统管理'}, { name: "字典管理" }]
        },{
            path: "/functionconfig",
            component: functionconfig,
            meta: [{ name: '系统管理'}, { name: "功能配置" }]
        }, {
            path: "/PrecisionCustomerConfig",
            component: PrecisionCustomerConfig,
            meta: [{ name: '系统管理' }, { name: "精准客户配置" }]
        }, {
            path: "/ringcontentkeyword",
            component: ringcontentkeyword,
            meta: [{ name: '系统管理' }, { name: "录音识别配置" }]
        }]
    },

    // 修改密码 & 修改手机
    {
        path: "/",
        component: Home,
        name: "修改密码",
        children: [{
            path: "/modify",
            component: modify,
            meta: [{ name: '修改设置'}, { name: "修改设置" }]
        },]
    },

    // 平台公告
    {
        path: "/",
        component: Home,
        name: "平台公告",
        leaf: true,
        children: [{
            path: "/notice",
            component: notice,
            name: "平台公告"
        }]
    },

    // 公告
    {   path: "/",
        component: Home,
        name: "公告",
        children: [{
            path: "/noticeList",
            component: noticeList,
            meta: [{ name: '公告'}, { name: "消息中心" }]
        }]
    },
];
export default new VueRouter({
    routes,
    // mode: "history"
})


// WEBPACK FOOTER //
// ./src/router/index.js